<template>
    <meta name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover">

    <div id="app">
        <router-view/>
        <!--        <div style="height: 2rem;background-color: #f3f3f3;"></div>-->
    </div>
    <van-number-keyboard safe-area-inset-bottom/>
</template>

// eslint-disable-next-line
<script>

export default {
    name: 'App',
    data() {

    },
    methods: {},
    created() {
        document.title = '罗马仕防伪查询';
    },
    components: {},
}
</script>

<style>

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #f3f3f3;
    margin-top: 60px;
}

/**
 * 适配 iphone 底部安全区（指示条，配合index.html <meta name="viewport" ... />使用
 */


</style>
